import React from "react";
import { Link } from "react-router-dom";

import { useAssetManagerWorkspace } from "../hooks/useAssetManagerWorkspace";
import { useAuth } from "../store/AuthContext";

export default function AssetManagerDashboardPage() {
  const { user } = useAuth();
  const { assignedProjects, pnlRows, pendingPnlCount, pnlEligibleProjects, message } = useAssetManagerWorkspace();

  const approvedCount = pnlRows.filter((r) => String(r.status || "").toUpperCase() === "APPROVED").length;

  return (
    <div className="page">
      <h2>Asset Manager Dashboard</h2>
      <p style={{ margin: 0 }}>
        Welcome, <strong>{user?.full_name}</strong>
      </p>
      {message && <p className="msg">{message}</p>}

      <div className="kpis" style={{ marginTop: 16 }}>
        <div className="kpi">
          <div className="kpi-label">Assigned projects</div>
          <div className="kpi-value">{assignedProjects.length}</div>
        </div>
        <div className="kpi">
          <div className="kpi-label">Active (P&amp;L eligible)</div>
          <div className="kpi-value">{pnlEligibleProjects.length}</div>
        </div>
        <div className="kpi">
          <div className="kpi-label">Pending P&amp;L</div>
          <div className="kpi-value">{pendingPnlCount}</div>
        </div>
        <div className="kpi">
          <div className="kpi-label">Approved submissions</div>
          <div className="kpi-value">{approvedCount}</div>
        </div>
      </div>

      <div className="grid-2" style={{ marginTop: 20, gap: 14 }}>
        <Link to="/asset-manager/projects" className="card" style={{ padding: 16, textDecoration: "none", color: "inherit" }}>
          <h3 style={{ marginTop: 0 }}>Assigned Projects</h3>
          <p className="muted" style={{ margin: 0, fontSize: 13 }}>
            View all projects you manage, pending P&amp;L tasks, and submit updates.
          </p>
        </Link>
        <Link to="/asset-manager/history/pnl" className="card" style={{ padding: 16, textDecoration: "none", color: "inherit" }}>
          <h3 style={{ marginTop: 0 }}>My History</h3>
          <p className="muted" style={{ margin: 0, fontSize: 13 }}>
            P&amp;L submissions, commission earnings, and your operational transaction history.
          </p>
        </Link>
      </div>
    </div>
  );
}
